import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from './Header.module.css';

const LINKS = [
  { to:'/evaluation',   label:'Evaluation' },
  { to:'/capabilities', label:'Capabilities' },
  { to:'/workflow',     label:'Workflow' },
  { to:'/analytics',    label:'Analytics' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive:true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`${styles.nav} ${scrolled ? styles.scrolled : ''}`} role="navigation" aria-label="Main navigation">
      <div className={`wrap ${styles.inner}`}>
        <Link to="/" className={styles.logo} aria-label="ReadIQ Home">
          {/* <div className={styles.badge}>RIQ</div> */}
          <img className='logosvg' src='/images/logo.svg' alt='ReadIQ'></img>
          <div>
            {/* <div className={styles.name} logoColor>Read<span>IQ</span>.ai</div>*/}
            <img src='/images/title.png' alt='ReadIQ' className='logotitle'></img>
            <div className={styles.tagline}>Content Intelligence - Built for humans, Ready for AI</div>
          </div>
        </Link>

        <ul className={`${styles.links} ${menuOpen ? styles.open : ''}`} role="list">
          {LINKS.map(l => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                className={({ isActive }) => isActive ? `${styles.link} ${styles.active}` : styles.link}
                onClick={() => setMenuOpen(false)}
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className={styles.actions}>
          <Link to="/request-demo" className={styles.cta}>Request Demo</Link>
          <button
            className={styles.burger}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(o => !o)}
          >
            <span/><span/><span/>
          </button>
        </div>
      </div>
    </nav>
  );
}
